module.exports = __webpack_public_path__ + "img/logo.bb8c65c4.png";